import React from 'react';

const SomeSpinner = () => (

    <div>
        <p>Loading...</p>
    </div>
);

export default SomeSpinner;